import * as React from 'react'

import type { IconProps } from '@/icons/types'
export const Link = React.forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, ref) => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={15} height={15} fill='none' ref={ref} {...props}>
			<g stroke={color} strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.5} clipPath='url(#a)'>
				<path d='m6.44 3.965 1.59-1.591a3.25 3.25 0 1 1 4.597 4.596l-1.591 1.59M3.964 6.44l-1.59 1.59a3.25 3.25 0 1 0 4.596 4.597l1.59-1.591M5.909 9.09 9.091 5.91' />
			</g>
			<defs>
				<clipPath id='a'>
					<path fill='#fff' d='M0 0h15v15H0z' />
				</clipPath>
			</defs>
		</svg>
	)
})
Link.displayName = 'Link'
